import React, { useEffect, useMemo, useCallback, useState } from 'react';
import { UploadOutlined } from '@ant-design/icons';
import { Upload, Spin } from 'antd';

import useUploadImage from '../../hooks/use-upload-image';
import ImageViewer from './../image-viewer';

import style from './index.less';

const UploadImage = React.forwardRef((props, _ref) => {
  const {
    value = '',
    beforeUpload = () => true,
    onChange = () => null,
    resetFields = () => null,
    type = 'widget',
    accept = 'image/png, image/jpeg, .jpg',
    className = '',
    disabled = true,
    previewLocalFile = false, // 通过本地文件预览，而不是 url
    isOnChangeKey = false, // 是否在 onChange 时返回 key
    view,
    renderBtn
  } = props;

  const { handleUploadImage } = useUploadImage();
  const [previewURL, setPreviewURL] = useState(null);
  const [loading, setLoading] = useState(false);
  const [viewerVisible, setViewerVisible] = useState(false);

  useEffect(() => {
    return () => {
      setPreviewURL(null);
      return resetFields();
    };
  }, []);

  const uploadHandler = useCallback(
    file => {
      if (!beforeUpload(file)) {
        return false;
      }
      setLoading(true);
      handleUploadImage({ file, type })
        .then(({ data: res }) => {
          if (previewLocalFile) {
            const reader = new FileReader();
            reader.onloadend = () => {
              setPreviewURL(reader.result);
            };
            reader.readAsDataURL(file);
          }
          if (isOnChangeKey) {
            onChange(res.photo_key);
          } else {
            onChange(res.photo_url);
          }
          setLoading(false);
        })
        .catch(() => setLoading(false));
      return false;
    },
    [type, onChange]
  );

  const imgStyle = useMemo(() => {
    return {
      backgroundImage: `url(${previewURL || value})` // Use previewURL if available, otherwise use the uploaded URL (value)
    };
  }, [previewURL, value]);

  return (
    <Upload
      disabled={disabled}
      className={style.outer}
      accept={accept}
      beforeUpload={uploadHandler}
      showUploadList={false}
    >
      {loading ? (
        <div className={style.loading}>
          <Spin spinning />
        </div>
      ) : null}
      {previewURL || value ? (
        <div
          className={`${className} ${style.preview} ${style.wrap} ${disabled ? style.disabled : ''}`}
          style={imgStyle}
        >
          {disabled ? null : (
            <div className={style.mask}>
              <div className={style.btn}>
                <span>{'重新上传'}</span>
              </div>
              {view ? (
                <div className={style.btn}>
                  <span
                    onClick={e => {
                      e.preventDefault();
                      e.stopPropagation();
                      setViewerVisible(true);
                    }}
                  >
                    {'预览'}
                  </span>
                </div>
              ) : null}
            </div>
          )}
        </div>
      ) : renderBtn ? (
        <>{renderBtn(loading)}</>
      ) : (
        <div className={`${className} ${style.wrap} ${disabled ? style.disabled : ''}`}>
          <div>
            <UploadOutlined />
            <div className={style.text}>{'上传图片'}</div>
          </div>
        </div>
      )}
      {view ? (
        <ImageViewer
          data={{
            imageList: [{ src: previewURL || value, alt: '' }], // Use previewURL if available, otherwise use the uploaded URL (value)
            viewerVisible
          }}
          setViewerVisible={setViewerVisible}
        />
      ) : null}
    </Upload>
  );
});

export default UploadImage;
